module.exports = __webpack_public_path__ + "static/media/load-failed.23261a38.png";